import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

function GraduationCapCircleIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()

  return (
    <svg fill="none" viewBox="0 0 67 67" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={`${pathClassName ? `stroke-current ${pathClassName} ` : ''}`}
        d="M33.2143 1.07143C50.9664 1.07143 65.3571 15.4622 65.3571 33.2143C65.3571 50.9664 50.9664 65.3571 33.2143 65.3571C15.4622 65.3571 1.07143 50.9664 1.07143 33.2143C1.07143 15.4622 15.4627 1.07143 33.2143 1.07143Z"
        fill="#467aff"
        stroke="white"
        strokeWidth="2.14286"
      />
      <g
        className={`${pathClassName ? `stroke-current ${pathClassName} ` : ''}`}
        clipPath={`url(#${uuid}clip0_194:5816)`}
      >
        <path d="M49.2857 27.725H47.8571V42.8571H49.2857V27.725Z" fill="white" />
        <path
          d="M48.5715 46.1428C48.5715 46.1428 50 44.3607 50 43.5714C50 42.7821 49.3607 42.1428 48.5715 42.1428C47.7822 42.1428 47.1429 42.7821 47.1429 43.5714C47.1429 44.3607 48.5715 46.1428 48.5715 46.1428Z"
          fill="#F6EFFF"
        />
        <path
          d="M32.3943 35.9893L16.8993 29.5329C16.2714 29.2714 16.2714 28.3814 16.8993 28.12L32.3943 21.6643C33.1479 21.35 33.9957 21.35 34.7493 21.6643L50.2436 28.12C50.8714 28.3814 50.8714 29.2714 50.2436 29.5329L34.7493 35.9886C33.995 36.3029 33.1479 36.3029 32.3943 35.9893Z"
          fill="white"
        />
        <path
          d="M33.5714 28.5715C27.6543 28.5715 22.8571 29.5994 22.8571 30.8672V40.7144C28.9793 40.7144 33.5714 43.5715 33.5714 43.5715C33.5714 43.5715 38.1636 40.7144 44.2857 40.7144V30.8672C44.2857 29.5994 39.4886 28.5715 33.5714 28.5715Z"
          fill="#F6EFFF"
        />
      </g>
    </svg>
  )
}

export default GraduationCapCircleIcon
